import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import {
  ClosedWonQueueSubmissionsDashboardDTO,
  ClosedWonQueueSubmissionsState,
} from './typings'
import { getClosedWonQueueSubmissions, getPrefs, postPrefs } from './api'
import { StoreData } from '@user/store/reducers/typings'

const closedWonQueueSubmissionsAdapterAdapter =
  createEntityAdapter<ClosedWonQueueSubmissionsDashboardDTO>({
    selectId: (opp) => opp.opportunityId,
  })

export const initialState: ClosedWonQueueSubmissionsState = {
  assigneeId: null,
  count: 0,
  isLoading: false,
  items: closedWonQueueSubmissionsAdapterAdapter.getInitialState(),
  numberOfDays: 30,
  page: 1,
  salesTeamId: null,
  showFront: true,
  skip: 0,
  take: 0,
}

const closedWonQueueSubmissionsSlice = createSlice({
  name: 'dashboard/closedWonQueueSubmissions',
  initialState: initialState,
  reducers: {
    flipCard: (state: ClosedWonQueueSubmissionsState) => {
      state.showFront = !state.showFront
    },
    setNumberOfdays: (
      state: ClosedWonQueueSubmissionsState,
      action: PayloadAction<number>,
    ) => {
      state.numberOfDays = action.payload
    },
    setPage: (
      state: ClosedWonQueueSubmissionsState,
      action: PayloadAction<number>,
    ) => {
      state.page = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getClosedWonQueueSubmissions.fulfilled,
      (state, { payload }) => {
        closedWonQueueSubmissionsAdapterAdapter.setAll(
          state.items,
          payload.items,
        )
        state.isLoading = false
        state.take = payload.take
        state.count = payload.count
        state.skip = payload.skip
      },
    )
    builder.addCase(getClosedWonQueueSubmissions.pending, (state) => {
      closedWonQueueSubmissionsAdapterAdapter.removeAll(state.items)
      state.isLoading = true
    })
    builder.addCase(postPrefs.fulfilled, (state, { payload }) => {
      state.assigneeId = payload.assigneeId
      state.salesTeamId = payload.salesTeamId
    })
    builder.addCase(getPrefs.fulfilled, (state, { payload }) => {
      state.numberOfDays = payload.numberOfDays ?? null
    })
  },
})

export const selectClosedWonQueueSubmissionsSettings = (state: StoreData) => {
  return state.dashboard.closedWonQueueSubmissions
}

export const closedWonQueueSubmissionsSelectors =
  closedWonQueueSubmissionsAdapterAdapter.getSelectors<StoreData>(
    (state) => state.dashboard.closedWonQueueSubmissions.items,
  )
export const { selectAll: selectAllClosedWonQueueSubmissions } =
  closedWonQueueSubmissionsSelectors

export const { flipCard, setNumberOfdays, setPage } =
  closedWonQueueSubmissionsSlice.actions
export const reducer = closedWonQueueSubmissionsSlice.reducer
